// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"c6021755","227":"fb707465","802":"c493b321"}[chunkId] + ".chunk.js";
};